import { useMutation, useQueryClient } from '@tanstack/react-query';
import { inviteUser } from '@services/users.service';
import { USERS_QUERY_KEY } from './useUsers';

export const useInviteUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => inviteUser(body),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: USERS_QUERY_KEY });
        },
    });
};
